// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2gfQ_","imageUploader":"EGiftCard_imageUploader__2Uw4Y"};